import demoSubtitles from './subtitles.json'

const zhTranslations = {
  subtitles: [
    '很多人想说英语。',
    '他们想流利地说，不害怕，不停顿，',
    '也不会忘词。',
    '但当他们尝试开口时，',
    '他们会感到紧张。',
    '他们张开嘴，',
    '却说不出话。',
    '他们的大脑一片空白。',
    '他们忘了自己想说什么，感到害羞，也感到害怕，',
    '然后就停下来了。他们会想，',
    '我的英语不好。',
    '我永远不会流利。',
    '但这并不是真的。',
    '你可以流利地说英语。是的，你可以。',
    '你不需要说完美的英语。',
    '你不需要很难的大词。',
    '你只需要每天清楚、自信地说。',
    '流利地说英语意味着说得简单、自然，',
    '并且不害怕。今天，',
    '我会告诉你怎样做到这一点。',
    '我会用非常简单的英语告诉你，',
    '一步一步地，',
    '这样你就能跟上并理解全部内容。首先，',
    '让我们先理解流利英语是什么意思。',
    '很多人认为流利英语意味着使用很难的词，',
    '复杂的语法，',
    '或者很长的句子，',
    '但那并不是真的。',
    '流利英语意味着你能说话时不过度停顿。',
    '流利英语意味着你能用英语分享自己的想法。',
    '即使你犯一些小错误，也能说出你想说的话。',
    '这没关系。',
    '如果对方能理解你，',
    '那你的英语就在发挥作用。所以请记住，',
    '流利并不意味着完美。',
    '流利意味着舒服和轻松。现在，',
    '我们来谈谈第一步。',
    '第一步，也是最重要的一步，是听。是的，',
    '听是关键。',
    '在你说得好之前，',
    '你必须先听得好。',
    '想想婴儿是如何学习语言的。',
    '婴儿每天听妈妈和爸爸说话。',
    '婴儿在开口前会听很多个月。',
    '婴儿不会读语法书。',
    '婴儿只是听。',
    '很多个月之后，',
    '婴儿开始说话。',
    '这就是大脑学习语言的方式。',
    '所以如果你想流利地说英语，',
    '从听开始。',
    '每天听英语。',
    '你可以听英语播客，',
    '英语歌曲，',
    '英语动画片，',
    '短篇故事，',
    'YouTube 视频，',
    '甚至英语新闻。',
    '你不必理解每一个词。',
    '只要享受声音。',
    '让这些词进入你的耳朵。',
    '你的大脑会记住，',
    '慢慢地你就会开始说得更好。',
    '现在我们进入第二步。',
    '这一步是每天开口说。是的。',
    '每天都说。',
    '即使你感到害羞，也要说。',
    '即使你会犯错，也要说。',
    '即使你没有人可以交谈，也要说。',
    '你可以和自己说话。',
    '你可以站在镜子前说话。',
    '你可以说一些简单的句子，比如，',
    '我是，或者这是我的房间，',
    '或者今天是美好的一天。',
    '当你一遍又一遍地说，',
    '你的嘴巴会习惯英语。',
    '你的舌头和嘴唇会开始更轻松地移动。',
    '你会说得更快。',
    '你会说得更好。',
    '说话就像锻炼。',
    '你做得越多，',
    '你就会变得越强。',
    '所以不要等别人来和你说话。',
    '你先开始。',
    '每天独自大声说出来。'
  ],
  completeSubtitles: [
    '很多人想说英语。',
    '他们想流利地说，不害怕，不停顿，也不会忘词。',
    '但当他们尝试开口时，他们会感到紧张。',
    '他们张开嘴，却说不出话。',
    '他们的大脑一片空白。',
    '他们忘了自己想说什么，感到害羞，也感到害怕，然后就停下来了。',
    '他们会想，我的英语不好。',
    '我永远不会流利。',
    '但这并不是真的。',
    '你可以流利地说英语。',
    '是的，你可以。',
    '你不需要说完美的英语。',
    '你不需要很难的大词。',
    '你只需要每天清楚、自信地说。',
    '流利地说英语意味着说得简单、自然，并且不害怕。',
    '今天，我会告诉你怎样做到这一点。',
    '我会用非常简单的英语一步一步地告诉你，这样你就能跟上并理解全部内容。',
    '首先，让我们先理解流利英语是什么意思。',
    '很多人认为流利英语意味着使用很难的词、复杂的语法或者很长的句子，但那并不是真的。',
    '流利英语意味着你能说话时不过度停顿。',
    '流利英语意味着你能用英语分享自己的想法。',
    '即使你犯一些小错误，也能说出你想说的话。',
    '这没关系。',
    '如果对方能理解你，那你的英语就在发挥作用。',
    '所以请记住，流利并不意味着完美。',
    '流利意味着舒服和轻松。',
    '现在，我们来谈谈第一步。',
    '第一步，也是最重要的一步，是听。',
    '是的，听是关键。',
    '在你说得好之前，你必须先听得好。',
    '想想婴儿是如何学习语言的。',
    '婴儿每天听妈妈和爸爸说话。',
    '婴儿在开口前会听很多个月。',
    '婴儿不会读语法书。',
    '婴儿只是听。',
    '很多个月之后，婴儿开始说话。',
    '这就是大脑学习语言的方式。',
    '所以如果你想流利地说英语，就从听开始。',
    '每天听英语。',
    '你可以听英语播客、英语歌曲、英语动画片、短篇故事、YouTube 视频，甚至英语新闻。',
    '你不必理解每一个词。',
    '只要享受声音。',
    '让这些词进入你的耳朵。',
    '你的大脑会记住，慢慢地你就会开始说得更好。',
    '现在我们进入第二步。',
    '这一步是每天开口说。',
    '是的。',
    '每天都说。',
    '即使你感到害羞，也要说。',
    '即使你会犯错，也要说。',
    '即使你没有人可以交谈，也要说。',
    '你可以和自己说话。',
    '你可以站在镜子前说话。',
    '你可以说一些简单的句子，比如：我是，或者这是我的房间，或者今天是美好的一天。',
    '当你一遍又一遍地说，你的嘴巴会习惯英语。',
    '你的舌头和嘴唇会开始更轻松地移动。',
    '你会说得更快。',
    '你会说得更好。',
    '说话就像锻炼。',
    '你做得越多，就会变得越强。',
    '所以不要等别人来和你说话。',
    '你先开始。',
    '每天独自大声说出来。'
  ]
}

const subtitleOnlyTranslations = {
  ja: [
    '多くの人が英語を話したいと思っています。',
    '彼らは恐れず、止まらずに流暢に話したいと思っています。',
    'そして単語を忘れずに話したいのです。',
    'でも話そうとすると、',
    '緊張してしまいます。',
    '口を開いても、',
    '言葉が出てきません。',
    '頭が真っ白になります。',
    '言いたいことを忘れ、恥ずかしくなり、怖くなって、',
    'そして止まってしまいます。彼らは思います、',
    '私の英語は上手ではない。',
    '私は永遠に流暢になれない。',
    'でも、それは本当ではありません。',
    'あなたは英語を流暢に話せます。はい、できます。',
    '完璧な英語を話す必要はありません。',
    '難しい大きな単語は必要ありません。',
    '必要なのは、毎日、はっきりと自信を持って話すことだけです。',
    '流暢に話すとは、簡単に自然に話すことです。',
    'そして恐れずに話すことです。今日は、',
    'その方法をお伝えします。',
    'とてもやさしい英語でお話しします。',
    '一歩ずつ、',
    'そうすれば、すべてについてきて理解できます。まず、',
    '流暢な英語とは何かを理解しましょう。',
    '多くの人は、流暢な英語とはとても難しい単語を使うことだと思っています。',
    '複雑な文法、',
    'または長い文を使うことだと思っています。',
    'でも、それは本当ではありません。',
    '流暢な英語とは、あまり止まらずに話せることです。',
    '流暢な英語とは、自分の考えを英語で伝えられることです。',
    '小さな間違いをしても、言いたいことを言えます。',
    'それで大丈夫です。',
    '相手があなたを理解できるなら、',
    'あなたの英語は役に立っています。だから覚えておいてください、',
    '流暢とは完璧という意味ではありません。',
    '流暢とは、心地よく簡単に話せることです。では、',
    '最初のステップについて話しましょう。',
    '最初で最も大切なステップは聞くことです。はい、',
    '聞くことが鍵です。',
    '上手に話す前に、',
    'よく聞かなければなりません。',
    '赤ちゃんが言語を学ぶ方法を考えてみてください。',
    '赤ちゃんは毎日、母親と父親の声を聞きます。',
    '赤ちゃんは話す前に何か月も聞きます。',
    '赤ちゃんは文法書を読みません。',
    '赤ちゃんはただ聞きます。',
    '何か月もたった後、',
    '赤ちゃんは話し始めます。',
    'これが脳が言語を学ぶ方法です。',
    'だから英語を流暢に話したいなら、',
    '聞くことから始めましょう。',
    '毎日英語を聞きましょう。',
    '英語のポッドキャストを聞くことができます。',
    '英語の歌、',
    '英語のアニメ、',
    '短い物語、',
    'YouTubeの動画、',
    'あるいは英語のニュースでもかまいません。',
    'すべての単語を理解する必要はありません。',
    '音を楽しむだけでいいです。',
    '言葉を耳に入れましょう。',
    'あなたの脳は覚えます。',
    'そして少しずつ、よりよく話せるようになります。',
    'では第二のステップに進みましょう。',
    'このステップは毎日話すことです。はい。',
    '毎日必ず話しましょう。',
    '恥ずかしくても話しましょう。',
    '間違えても話しましょう。',
    '話す相手がいなくても話しましょう。',
    '自分自身に話しかけることができます。',
    '鏡の前に立って話すことができます。',
    '例えば、簡単な文を言うことができます。',
    '私は、またはこれは私の部屋です、',
    'あるいは今日は良い日です。',
    '何度も何度も話すと、',
    '口が英語に慣れてきます。',
    '舌と唇が楽に動き始めます。',
    'より速く話せます。',
    'より上手に話せます。',
    '話すことは運動のようなものです。',
    'やればやるほど、',
    'あなたは強くなります。',
    'だから誰かが話しかけてくるのを待たないでください。',
    'あなたが先に始めましょう。',
    '毎日、一人で声に出して話しましょう。'
  ],
  ko: [
    '많은 사람들이 영어를 말하고 싶어 합니다.',
    '그들은 두려움 없이, 멈추지 않고 유창하게 말하고 싶어 합니다.',
    '그리고 단어를 잊지 않고 말하고 싶어 합니다.',
    '하지만 말하려고 하면,',
    '긴장하게 됩니다.',
    '입을 열지만,',
    '말이 나오지 않습니다.',
    '머릿속이 하얘집니다.',
    '하고 싶은 말을 잊고, 부끄럽고, 무서워져서,',
    '그러다 멈춥니다. 그들은 생각합니다,',
    '내 영어는 좋지 않아.',
    '나는 절대 유창해질 수 없어.',
    '하지만 이것은 사실이 아닙니다.',
    '당신은 영어를 유창하게 말할 수 있습니다. 네, 할 수 있습니다.',
    '완벽한 영어를 말할 필요는 없습니다.',
    '어려운 큰 단어가 필요하지 않습니다.',
    '필요한 것은 매일 또렷하고 자신 있게 말하는 것뿐입니다.',
    '유창하게 말한다는 것은 쉽고 자연스럽게 말한다는 뜻입니다.',
    '그리고 두려움 없이 말한다는 뜻입니다. 오늘은,',
    '그 방법을 알려 드리겠습니다.',
    '아주 쉬운 영어로 알려 드리겠습니다.',
    '단계별로,',
    '그래서 모든 내용을 따라오고 이해할 수 있습니다. 먼저,',
    '유창한 영어가 무엇을 의미하는지 이해해 봅시다.',
    '많은 사람들은 유창한 영어가 아주 어려운 단어를 쓰는 것이라고 생각합니다.',
    '복잡한 문법,',
    '또는 긴 문장이라고 생각합니다.',
    '하지만 그것은 사실이 아닙니다.',
    '유창한 영어는 너무 많이 멈추지 않고 말할 수 있다는 뜻입니다.',
    '유창한 영어는 자신의 생각을 영어로 나눌 수 있다는 뜻입니다.',
    '작은 실수를 하더라도 말하고 싶은 것을 말할 수 있습니다.',
    '괜찮습니다.',
    '상대방이 당신을 이해한다면,',
    '당신의 영어는 제 역할을 하고 있는 것입니다. 그러니 기억하세요,',
    '유창함은 완벽함을 뜻하지 않습니다.',
    '유창함은 편안하고 쉽게 말하는 것입니다. 이제,',
    '첫 번째 단계에 대해 이야기해 봅시다.',
    '첫 번째이자 가장 중요한 단계는 듣기입니다. 네,',
    '듣기가 핵심입니다.',
    '말을 잘하기 전에,',
    '잘 들어야 합니다.',
    '아기가 언어를 배우는 방식을 생각해 보세요.',
    '아기는 매일 엄마와 아빠의 말을 듣습니다.',
    '아기는 말하기 전에 여러 달 동안 듣습니다.',
    '아기는 문법책을 읽지 않습니다.',
    '아기는 그냥 듣습니다.',
    '여러 달이 지난 뒤,',
    '아기는 말하기 시작합니다.',
    '이것이 뇌가 언어를 배우는 방식입니다.',
    '그러니 영어를 유창하게 말하고 싶다면,',
    '듣기부터 시작하세요.',
    '매일 영어를 들으세요.',
    '영어 팟캐스트를 들을 수 있습니다.',
    '영어 노래,',
    '영어 만화,',
    '짧은 이야기,',
    'YouTube 영상,',
    '또는 영어 뉴스도 좋습니다.',
    '모든 단어를 이해할 필요는 없습니다.',
    '그저 소리를 즐기세요.',
    '단어들이 귀로 들어오게 하세요.',
    '당신의 뇌가 기억할 것입니다.',
    '그리고 천천히 더 잘 말하기 시작할 것입니다.',
    '이제 두 번째 단계로 넘어갑시다.',
    '이 단계는 매일 말하는 것입니다. 네.',
    '매일 빠짐없이 말하세요.',
    '부끄러워도 말하세요.',
    '실수해도 말하세요.',
    '말할 사람이 없어도 말하세요.',
    '혼잣말을 할 수 있습니다.',
    '거울 앞에 서서 말할 수 있습니다.',
    '예를 들어 간단한 문장을 말할 수 있습니다.',
    '나는, 또는 이것은 내 방입니다,',
    '또는 오늘은 좋은 날입니다.',
    '계속 반복해서 말하면,',
    '입이 영어에 익숙해집니다.',
    '혀와 입술이 더 쉽게 움직이기 시작합니다.',
    '더 빠르게 말합니다.',
    '더 잘 말합니다.',
    '말하기는 운동과 같습니다.',
    '더 많이 할수록,',
    '더 강해집니다.',
    '그러니 누군가가 말을 걸어 주기를 기다리지 마세요.',
    '당신이 먼저 시작하세요.',
    '매일 혼자서 크게 말하세요.'
  ],
  es: [
    'Muchas personas quieren hablar inglés.',
    'Quieren hablar con fluidez, sin miedo y sin detenerse,',
    'y sin olvidar palabras.',
    'Pero cuando intentan hablar,',
    'se sienten nerviosas.',
    'Abren la boca,',
    'pero no sale ninguna palabra.',
    'Su mente se queda en blanco.',
    'Olvidan lo que quieren decir, sienten vergüenza y sienten miedo,',
    'y luego se detienen. Piensan,',
    'mi inglés no es bueno.',
    'Nunca hablaré con fluidez.',
    'Pero esto no es verdad.',
    'Puedes hablar inglés con fluidez. Sí, puedes.',
    'No necesitas hablar un inglés perfecto.',
    'No necesitas palabras grandes y difíciles.',
    'Solo necesitas hablar con claridad, confianza y todos los días.',
    'Hablar con fluidez significa hablar de forma simple y fácil,',
    'y sin miedo. Hoy,',
    'te diré cómo hacerlo.',
    'Te lo diré en un inglés muy fácil,',
    'paso a paso,',
    'para que puedas seguir y entender todo. Primero,',
    'entendamos qué significa hablar inglés con fluidez.',
    'Muchas personas piensan que hablar inglés con fluidez significa usar palabras muy difíciles,',
    'gramática compleja,',
    'o frases largas,',
    'pero eso no es verdad.',
    'Hablar inglés con fluidez significa que puedes hablar sin detenerte demasiado.',
    'Hablar inglés con fluidez significa que puedes compartir tus ideas en inglés.',
    'Puedes decir lo que quieres decir aunque cometas pequeños errores.',
    'Eso está bien.',
    'Si la otra persona te entiende,',
    'entonces tu inglés está funcionando. Así que recuerda,',
    'fluido no significa perfecto.',
    'Fluido significa cómodo y fácil. Ahora,',
    'hablemos del primer paso.',
    'El primer paso y el más importante es escuchar. Sí,',
    'escuchar es la clave.',
    'Antes de hablar bien,',
    'debes escuchar bien.',
    'Piensa en cómo los bebés aprenden un idioma.',
    'Un bebé escucha a su madre y a su padre todos los días.',
    'El bebé escucha durante muchos meses antes de hablar.',
    'El bebé no lee libros de gramática.',
    'El bebé solo escucha.',
    'Después de muchos meses,',
    'el bebé empieza a hablar.',
    'Así es como el cerebro aprende un idioma.',
    'Así que si quieres hablar inglés con fluidez,',
    'empieza escuchando.',
    'Escucha inglés todos los días.',
    'Puedes escuchar podcasts en inglés,',
    'canciones en inglés,',
    'dibujos animados en inglés,',
    'historias cortas,',
    'videos de YouTube,',
    'o incluso noticias en inglés.',
    'No tienes que entender cada palabra.',
    'Solo disfruta el sonido.',
    'Deja que las palabras entren en tus oídos.',
    'Tu cerebro recordará,',
    'y poco a poco empezarás a hablar mejor.',
    'Ahora pasemos al segundo paso.',
    'Este paso es hablar todos los días. Sí.',
    'Habla todos los días.',
    'Habla aunque te sientas tímido.',
    'Habla aunque cometas errores.',
    'Habla aunque no tengas a nadie con quien hablar.',
    'Puedes hablar contigo mismo.',
    'Puedes pararte frente al espejo y hablar.',
    'Puedes decir frases simples como,',
    'yo soy o esta es mi habitación,',
    'o hoy es un buen día.',
    'Cuando hablas una y otra vez,',
    'tu boca se acostumbra al inglés.',
    'Tu lengua y tus labios empiezan a moverse con facilidad.',
    'Hablas más rápido.',
    'Hablas mejor.',
    'Hablar es como hacer ejercicio.',
    'Cuanto más lo haces,',
    'más fuerte te vuelves.',
    'Así que no esperes a que alguien te hable.',
    'Empieza tú primero.',
    'Simplemente habla en voz alta, a solas, todos los días.'
  ],
  fr: [
    'Beaucoup de personnes veulent parler anglais.',
    'Elles veulent parler couramment, sans peur et sans s’arrêter,',
    'et sans oublier les mots.',
    'Mais quand elles essaient de parler,',
    'elles se sentent nerveuses.',
    'Elles ouvrent la bouche,',
    'mais aucun mot ne sort.',
    'Leur esprit devient vide.',
    'Elles oublient ce qu’elles veulent dire, elles se sentent timides et effrayées,',
    'puis elles s’arrêtent. Elles pensent,',
    'mon anglais n’est pas bon.',
    'Je ne parlerai jamais couramment.',
    'Mais ce n’est pas vrai.',
    'Tu peux parler anglais couramment. Oui, tu peux.',
    'Tu n’as pas besoin de parler un anglais parfait.',
    'Tu n’as pas besoin de grands mots difficiles.',
    'Tu dois seulement parler clairement, avec confiance, et tous les jours.',
    'Parler couramment signifie parler simplement et facilement,',
    'et sans peur. Aujourd’hui,',
    'je vais te dire comment faire.',
    'Je vais te l’expliquer dans un anglais très facile,',
    'étape par étape,',
    'pour que tu puisses suivre et tout comprendre. D’abord,',
    'comprenons ce que signifie parler anglais couramment.',
    'Beaucoup de personnes pensent que parler anglais couramment signifie utiliser des mots très difficiles,',
    'une grammaire compliquée,',
    'ou de longues phrases,',
    'mais ce n’est pas vrai.',
    'Parler anglais couramment signifie pouvoir parler sans trop s’arrêter.',
    'Parler anglais couramment signifie pouvoir partager tes idées en anglais.',
    'Tu peux dire ce que tu veux dire même si tu fais de petites erreurs.',
    'Ce n’est pas grave.',
    'Si l’autre personne te comprend,',
    'alors ton anglais fonctionne. Alors souviens-toi,',
    'courant ne veut pas dire parfait.',
    'Courant signifie confortable et facile. Maintenant,',
    'parlons de la première étape.',
    'La première étape, et la plus importante, est l’écoute. Oui,',
    'l’écoute est la clé.',
    'Avant de bien parler,',
    'tu dois bien écouter.',
    'Pense à la façon dont les bébés apprennent une langue.',
    'Un bébé écoute sa mère et son père tous les jours.',
    'Le bébé écoute pendant de nombreux mois avant de parler.',
    'Le bébé ne lit pas de livres de grammaire.',
    'Le bébé écoute simplement.',
    'Après de nombreux mois,',
    'le bébé commence à parler.',
    'C’est ainsi que le cerveau apprend une langue.',
    'Donc si tu veux parler anglais couramment,',
    'commence par écouter.',
    'Écoute de l’anglais tous les jours.',
    'Tu peux écouter des podcasts en anglais,',
    'des chansons en anglais,',
    'des dessins animés en anglais,',
    'des histoires courtes,',
    'des vidéos YouTube,',
    'ou même les informations en anglais.',
    'Tu n’as pas besoin de comprendre chaque mot.',
    'Profite simplement du son.',
    'Laisse les mots entrer dans tes oreilles.',
    'Ton cerveau s’en souviendra,',
    'et peu à peu tu commenceras à mieux parler.',
    'Passons maintenant à la deuxième étape.',
    'Cette étape consiste à parler tous les jours. Oui.',
    'Parle chaque jour.',
    'Parle même si tu te sens timide.',
    'Parle même si tu fais des erreurs.',
    'Parle même si tu n’as personne à qui parler.',
    'Tu peux te parler à toi-même.',
    'Tu peux te tenir devant le miroir et parler.',
    'Tu peux dire des phrases simples comme,',
    'je suis ou ceci est ma chambre,',
    'ou aujourd’hui est une bonne journée.',
    'Quand tu parles encore et encore,',
    'ta bouche s’habitue à l’anglais.',
    'Ta langue et tes lèvres commencent à bouger facilement.',
    'Tu parles plus vite.',
    'Tu parles mieux.',
    'Parler, c’est comme faire de l’exercice.',
    'Plus tu le fais,',
    'plus tu deviens fort.',
    'Alors n’attends pas que quelqu’un te parle.',
    'Commence toi-même.',
    'Parle simplement à voix haute, seul, tous les jours.'
  ],
  de: [
    'Viele Menschen möchten Englisch sprechen.',
    'Sie möchten fließend sprechen, ohne Angst und ohne anzuhalten,',
    'und ohne Wörter zu vergessen.',
    'Aber wenn sie versuchen zu sprechen,',
    'werden sie nervös.',
    'Sie öffnen den Mund,',
    'aber keine Wörter kommen heraus.',
    'Ihr Kopf wird leer.',
    'Sie vergessen, was sie sagen wollen, sie sind schüchtern und haben Angst,',
    'und dann hören sie auf. Sie denken,',
    'mein Englisch ist nicht gut.',
    'Ich werde nie fließend sprechen.',
    'Aber das stimmt nicht.',
    'Du kannst fließend Englisch sprechen. Ja, du kannst es.',
    'Du musst kein perfektes Englisch sprechen.',
    'Du brauchst keine großen schwierigen Wörter.',
    'Du musst nur klar, selbstbewusst und jeden Tag sprechen.',
    'Fließend zu sprechen bedeutet, einfach und leicht zu sprechen,',
    'und ohne Angst. Heute,',
    'werde ich dir sagen, wie das geht.',
    'Ich werde es dir in sehr einfachem Englisch sagen,',
    'Schritt für Schritt,',
    'damit du folgen und alles verstehen kannst. Zuerst,',
    'lass uns verstehen, was fließendes Englisch bedeutet.',
    'Viele Menschen denken, fließendes Englisch bedeutet, sehr schwierige Wörter zu benutzen,',
    'komplizierte Grammatik,',
    'oder lange Sätze,',
    'aber das stimmt nicht.',
    'Fließendes Englisch bedeutet, dass du sprechen kannst, ohne zu oft anzuhalten.',
    'Fließendes Englisch bedeutet, dass du deine Gedanken auf Englisch teilen kannst.',
    'Du kannst sagen, was du sagen möchtest, auch wenn du kleine Fehler machst.',
    'Das ist in Ordnung.',
    'Wenn die andere Person dich versteht,',
    'dann funktioniert dein Englisch. Also denk daran,',
    'fließend bedeutet nicht perfekt.',
    'Fließend bedeutet angenehm und einfach. Jetzt,',
    'sprechen wir über den ersten Schritt.',
    'Der erste und wichtigste Schritt ist Zuhören. Ja,',
    'Zuhören ist der Schlüssel.',
    'Bevor du gut sprichst,',
    'musst du gut zuhören.',
    'Denk daran, wie Babys eine Sprache lernen.',
    'Ein Baby hört jeden Tag Mutter und Vater zu.',
    'Das Baby hört viele Monate lang zu, bevor es spricht.',
    'Das Baby liest keine Grammatikbücher.',
    'Das Baby hört einfach zu.',
    'Nach vielen Monaten,',
    'beginnt das Baby zu sprechen.',
    'So lernt das Gehirn Sprache.',
    'Wenn du also fließend Englisch sprechen möchtest,',
    'fang mit dem Zuhören an.',
    'Höre jeden Tag Englisch.',
    'Du kannst englische Podcasts hören,',
    'englische Lieder,',
    'englische Zeichentrickfilme,',
    'kurze Geschichten,',
    'YouTube-Videos,',
    'oder sogar englische Nachrichten.',
    'Du musst nicht jedes Wort verstehen.',
    'Genieße einfach den Klang.',
    'Lass die Wörter in deine Ohren gehen.',
    'Dein Gehirn wird sich erinnern,',
    'und langsam wirst du anfangen, besser zu sprechen.',
    'Gehen wir nun zum zweiten Schritt.',
    'Dieser Schritt ist, jeden Tag zu sprechen. Ja.',
    'Sprich jeden einzelnen Tag.',
    'Sprich, auch wenn du schüchtern bist.',
    'Sprich, auch wenn du Fehler machst.',
    'Sprich, auch wenn du niemanden zum Reden hast.',
    'Du kannst mit dir selbst sprechen.',
    'Du kannst vor dem Spiegel stehen und sprechen.',
    'Du kannst einfache Sätze sagen wie,',
    'ich bin oder das ist mein Zimmer,',
    'oder heute ist ein guter Tag.',
    'Wenn du immer wieder sprichst,',
    'gewöhnt sich dein Mund an Englisch.',
    'Deine Zunge und deine Lippen beginnen, sich leichter zu bewegen.',
    'Du sprichst schneller.',
    'Du sprichst besser.',
    'Sprechen ist wie Sport.',
    'Je mehr du es tust,',
    'desto stärker wirst du.',
    'Warte also nicht darauf, dass jemand mit dir spricht.',
    'Fang du zuerst an.',
    'Sprich einfach laut, allein, jeden Tag.'
  ]
}

function buildCompleteTranslations(translatedSubtitles) {
  return demoSubtitles.completeSubtitles.map((completeSubtitle) => {
    return demoSubtitles.subtitles
      .map((subtitle, index) => ({ subtitle, text: translatedSubtitles[index] }))
      .filter(({ subtitle }) => subtitle.end > completeSubtitle.start && subtitle.start < completeSubtitle.end)
      .map(({ text }) => text)
      .join(' ')
  })
}

const demoTranslations = { zh: zhTranslations }

Object.entries(subtitleOnlyTranslations).forEach(([lang, subtitles]) => {
  demoTranslations[lang] = {
    subtitles,
    completeSubtitles: buildCompleteTranslations(subtitles)
  }
})

function getSourceSubtitles(splitType) {
  if (splitType === 'practice') return demoSubtitles.subtitles
  return splitType === 'period' ? demoSubtitles.completeSubtitles : demoSubtitles.subtitles
}

function withSourceTiming(sourceSubtitles, translatedTexts) {
  if (!translatedTexts || translatedTexts.length !== sourceSubtitles.length) return null
  return sourceSubtitles.map((subtitle, index) => ({
    ...subtitle,
    text: translatedTexts[index]
  }))
}

export function getDemoTranslatedSubtitles({ lang, splitType }) {
  const sourceSubtitles = getSourceSubtitles(splitType)

  if (lang === 'en') {
    return sourceSubtitles.map((subtitle) => ({ ...subtitle }))
  }

  const key = splitType === 'period' ? 'completeSubtitles' : 'subtitles'
  return withSourceTiming(sourceSubtitles, demoTranslations[lang]?.[key])

}
